import React, { Component, useState } from 'react';
import $ from "jquery";
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';



        function OnlineDetails() {
            const [name, setName] = useState("");
            const [phone, setPhone] = useState("");
            const [email, setEmail] = useState("");
            const [course, setCourse] = useState("");
            const [payment, setPayment] = useState("");
            const [transaction, setTransaction] = useState("");
            const [result, setResult] = useState("");
          
            const handleChange = (e) => {
                setName(e.target.value);
                setPhone(e.target.value);
                setEmail(e.target.value);
                setCourse(e.target.value);
                setPayment(e.target.value);
                setTransaction(e.target.value);
            };
          
            const handleSumbit = (e) => {
                e.preventDefault();
                const form = $(e.target);
                $.ajax({
                    type: "POST",
                    url: form.attr("action"),
                    data: form.serialize(),
                    success(data) {
                        setResult(data);
                        setName("");
                        setEmail("");
                        setPhone("");
                        setCourse("");
                        setPayment("");
                        setTransaction("");
                    },
                });
            };  

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="pricing-area pd-top-120 pd-bottom-90">
			  <div className="container">
			    <div className="row justify-content-center">
                    <div className='col-lg-12'>
                        <h2 className="title">Step 1</h2>
			            <p>For every course, Application fee: Rs.200/-</p>
                    </div>
			      <div className="col-lg-4 col-md-4">
			        <div className="single-pricing-inner-wrap" style={{minHeight: '380px'}}>
			          <div className="single-pricing-inner">
                        <h5 className="mb-0 mt-2">Net Banking</h5><br/>
			            <ul className="pricing-list" style={{textAlign:'left'}}>
			              <li><i className="fa fa-check" /><b style={{color:'#C3161C'}}>NAME:</b> MADRAS INSTITUTE OF ENGINEERING TECHNOLOGY</li>
			              <li><i className="fa fa-check" /><b style={{color:'#C3161C'}}>A/C NO.: </b>        048202000001918</li>
			              <li><i className="fa fa-check" /><b style={{color:'#C3161C'}}>IFSC CODE:</b>    IOBA000082</li>
			              <li><i className="fa fa-check" /><b style={{color:'#C3161C'}}>BRANCH:</b>        MAHALINGAPURAM(0482)</li>
			            </ul>
			          </div>
			        </div>
			      </div>


			      <div className="col-lg-4 col-md-4">
			        <div className="single-pricing-inner-wrap" style={{minHeight: '380px'}}>
			          <div className="single-pricing-inner">
                        <h5 className="mb-0 mt-2">UPI</h5><br/>
                        <img src={publicUrl+"assets/img/website/Gpay.jpg"} alt="img" />

                        <p style={{marginTop:30}}>Scan QR code or Gpay Number: <b>9444026120</b></p>
			          </div>
			        </div>
			      </div>


			      <div className="col-lg-4 col-md-4">
			        <div className="single-pricing-inner-wrap" style={{minHeight: '380px'}}>
			          <div className="single-pricing-inner">
                        <h5 className="mb-0 mt-2">Online Payment</h5><br/>
                        <img src={publicUrl+"assets/img/website/South.png"} alt="img" />
                        
                      <a href='https://feebook.southindianbank.com/FeeBookUser/org?id=836' target='blank' ><button style={{marginTop:40,backgroundColor:'#c31619',padding:"5px 25px",color:'#fff',borderRadius:30,border:'none',}}>Pay now!</button></a>
			          </div>
			        </div>
			      </div>


			    </div>
                <div className="row justify-content-center">
                    <div className='col-lg-12'>
                        <h2 className="title">Step 2</h2>
			            <p>After fee processing, Update details to get application</p>
                    </div>
			      <div className="col-lg-12 OnlineDetails">
                  <form className="contact-form-inner  style-shadow" action="https://mieteducation.in/server/mail.php" method="post" onSubmit={(event) => handleSumbit(event)}>
			          <div className="section-title">
			            {/* <h2 className="title">Update details</h2> */}
			            {/* <p>We will be happy to answer your questions.</p> */}
			          </div>
			          <div className="row">
			            <div className="col-md-6">
			              <div className="single-input-inner">
			                <input type="text" placeholder="Name" id="name"
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)} />
			              </div>
			            </div>
			            <div className="col-md-6">
			              <div className="single-input-inner">
			                <input type="text" placeholder="Phone Number" id="phone"
                            name="phone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}/>
			              </div>
			            </div>
			            <div className="col-md-6">
			              <div className="single-input-inner">
			                <input type="text" placeholder="Email Address" id="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}/>
			              </div>
			            </div>
                        
                        <div className="col-md-6">
			              <div className="single-input-inner">
			                <select id="course"
                                name="course"
                                value={course}
                                onChange={(e) => setCourse(e.target.value)}>
                                <option value="">Select Course</option>
                                <option value="NCVT Courses">NCVT Courses</option>
                                <option value="Industrial School Courses">Industrial School Courses</option>
                                <option value="NEET">NEET</option>
                                <option value="JEE">JEE</option>
                                <option value="NATA">NATA</option>
                                <option value="TMG College of Arts & Science">TMG College of Arts & Science</option>
                                <option value="University of Madras">University of Madras</option>
                                <option value="Bharathidasan University">Bharathidasan University</option>
                                <option value="Tamil Nadu Open University">Tamil Nadu Open University</option>
                                <option value="Data Science & AI">Data Science & AI</option>
                                <option value="Classes IX, X, XI, XII">Classes IX, X, XI, XII</option>
                                <option value="NRA CET">NRA CET</option>
                                <option value="Hotel Management & Catering Technology">Hotel Management & Catering Technology</option>
                            </select>
			              </div>
			            </div>
			            <div className="col-md-6">
			              <div className="single-input-inner">
			                <select id="payment"
                                name="payment"
                                value={payment}
                                onChange={(e) => setPayment(e.target.value)}>
                                <option value="">Select Payment Method</option>
                                <option value="Net Banking">Net Banking</option>
                                <option value="UPI">UPI</option>
                            </select>
			              </div>
			            </div>
                        <div className="col-md-6">
			              <div className="single-input-inner">
			                <input type="text" placeholder="Transaction Number" id="transaction"
                                name="transaction"
                                value={transaction}
                                onChange={(e) => setTransaction(e.target.value)}/>
			              </div>
			            </div>
			            <div className="col-sm-12 ">
                        <button className="btn btn-base btn-radius" type="submit" style={{color:'white'}}>Submit</button>
                        <h2 className="title">{result}</h2>
			            </div>
			          </div>
			        </form>
                  </div>
                </div>
			  </div>
			</div>

        }


export default OnlineDetails